export const formattedNumber = (value) => {
  let nf = new Intl.NumberFormat("en-US",{
    minimumFractionDigits: 2
  });
  return nf.format(value); // "1,234,567,890"
};
